var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-title"},[_c('h1',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm.title))]),_c('h3',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }